import { React, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { SHA256 } from "crypto-js";
import "../blockpay.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardContent,
  TextField,
  Button,
  Box,
  Typography,
  InputAdornment,
} from "@mui/material";
import { Link } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { setAuthToken } from "../../utils/setAuthToken";
import ChangePassModal from "./modals/changePassModal";
import ChangePinModal from "./modals/changePinModal";

export default function SettingForm() {
  const [status, setStatus] = useState(true);
  // Modal use State
  const [open, setOpen] = useState(false);
  const handleOpenModal = () => setOpen(true);
  const handleCloseModal = () => {
    setOpen(false);
    window.location.reload();
  };
  // Modal use State
  const [open2, setOpen2] = useState(false);
  const handleOpenModal2 = () => setOpen2(true);
  const handleCloseModal2 = () => {
    setOpen2(false);
    window.location.reload();
  };
  //backdrop usestates
  const [openbackdrop, setOpenbackdrop] = useState(false);
  const handleClose = () => {
    setOpenbackdrop(false);
  };
  const handleOpen = () => {
    setOpenbackdrop(true);
  };
  //Normal use states
  const [fname, setFName] = useState("");
  const [lname, setLName] = useState("");
  const [phone, setPhone] = useState("");
  const [mail, setMail] = useState("");
  const [pass, setPass] = useState("");
  const [pin, setPin] = useState("");
  const [busName, setbusName] = useState("");
  const navigate = useNavigate();
  // for update API
  const getMerchantDetails = (e) => {
    setAuthToken(localStorage.getItem("jwtToken"));
    axios
      .get("https://api.blockpay.co.za/merchant/getMerchantDetails", {})
      .then((res) => {
        console.log(res);
        handleClose();
        setFName(res.data.firstname);
        setLName(res.data.lastname);
        setPhone(res.data.phone);
        setMail(res.data.email);
        setPass(res.data.password);
        setPin(res.data.pin);
        setbusName(res.data.businessName);
        // toast.success(res.data.message);
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.response.data.message);
        setTimeout(() => {
          handleClose();
        }, 2000);

        if (err.response.data.message == "Unauthorized!") {
          axios
            .post("https://api.blockpay.co.za/auth/refreshToken", {
              refreshToken: localStorage.getItem("refreshToken"),
            })
            .then((res) => {
              console.log(res);
              localStorage.setItem("jwtToken", res.data.accessToken);
              setTimeout(() => {
                window.location.reload();
              }, 500);
            })
            .catch((err) => {
              console.log(err);
              localStorage.clear();
              window.location.reload();
            });
        }
      });
  };
  const handleSubmit2 = (e) => {
    e.preventDefault();
    setAuthToken(localStorage.getItem("jwtToken"));
    // toast.info("Update Succesful!");
    console.log("adfdasgfads");
    setTimeout(() => {
      axios
        .post("https://api.blockpay.co.za/merchant/updateMerchantDetails", {
          firstname: fname,
          lastname: lname,
          businessName: busName,
          phone: phone,
        })
        .then((res) => {
          console.log("adfdf");
          toast.success("Update Succesful!");
          console.log(res);
          handleOpen();
          localStorage.setItem("name", `${fname} ${lname}`);
          getMerchantDetails();
        })
        .catch((err) => {
          toast.error(err.response.data.message);

          console.log(err);
          if (err.response.data.message == "Unauthorized!") {
            axios
              .post("https://api.blockpay.co.za/auth/refreshToken", {
                refreshToken: localStorage.getItem("refreshToken"),
              })
              .then((res) => {
                console.log(res);
                localStorage.setItem("jwtToken", res.data.accessToken);
                setTimeout(() => {
                  window.location.reload();
                }, 500);
              })
              .catch((err) => {
                console.log(err);
                localStorage.clear();
                window.location.reload();
              });
          }
        });
    }, 1000);
  };
  useEffect(() => {
    handleOpen();
    getMerchantDetails();
  }, []);
  return (
    <>
      <ToastContainer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openbackdrop}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box
        className="loginCard"
        sx={{
          padding: "30px 15px",
          textAlign: "center",
          borderRadius: "15px !important",
          border: "solid 1px rgb(173, 171, 171)",
          marginLeft: "auto!important",
        }}
      >
        <CardContent>
          <form onSubmit={handleSubmit2}>
            <div
              style={{
                display: "flex",
                width: "100%",
                marginTop: "20px",
                marginBottom: "20px",
              }}
              className="signupNameGrid"
            >
              <TextField
                value={fname}
                sx={{
                  flexGrow: 1,
                  width: 0,
                  marginRight: "1rem",
                  borderRadius: "50px!important",
                }}
                InputLabelProps={{ shrink: true }}
                id="first-name"
                label="First Name"
                onChange={(event) => {
                  setFName(event.target.value);
                }}
                // placeholder={fname}
                variant="outlined"
              />

              <TextField
                label="Last Name"
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                value={lname}
                onChange={(event) => setLName(event.target.value)}
                sx={{ flexGrow: 1, width: 0 }}
              />
            </div>
            <TextField
              className="logintextField"
              label="Mobile Number"
              InputLabelProps={{ shrink: true }}
              value={phone}
              onChange={(event) => setPhone(event.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {/* <Typography
                      sx={{
                        color: "#0582FF",
                        fontWeight: "500",
                        fontSize: "0.875rem",
                      }}
                    >
                      Change Mobile No.
                    </Typography> */}
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              className="logintextField"
              label="Business Name"
              value={busName}
              onChange={(event) => setbusName(event.target.value)}
              InputLabelProps={{ shrink: true }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {/* <Typography
                      sx={{
                        color: "#0582FF",
                        fontWeight: "500",
                        fontSize: "0.875rem",
                      }}
                    >
                      Change Business Name
                    </Typography> */}
                  </InputAdornment>
                ),
              }}
              variant="outlined"
            />
            <TextField
              className="logintextField"
              label="Email address"
              value={mail}
              InputLabelProps={{ shrink: true }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {/* <Typography
                      sx={{
                        color: "#0582FF",
                        fontWeight: "500",
                        fontSize: "0.875rem",
                      }}
                    >
                      Change Email
                    </Typography> */}
                  </InputAdornment>
                ),
              }}
              variant="outlined"
              type="email"
            />
            <TextField
              className="logintextField"
              label="Password"
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              value={pass}
              type="password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Typography
                      sx={{
                        color: "#0582FF",
                        fontWeight: "500",
                        fontSize: "0.875rem",
                        textTransform: "none",
                      }}
                      onClick={handleOpenModal}
                      component={Button}
                    >
                      Change Password
                    </Typography>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              className="logintextField"
              label="Pin"
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              value={pin}
              type="password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Typography
                      sx={{
                        color: "#0582FF",
                        fontWeight: "500",
                        fontSize: "0.875rem",
                        textTransform: "none",
                      }}
                      onClick={handleOpenModal2}
                      component={Button}
                    >
                      Change Pin
                    </Typography>
                  </InputAdornment>
                ),
              }}
            />
            <Button
              className="loginButtonSignUp"
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              // onSubmit={handleSubmit}
            >
              <span className="buttonSignText">Save</span>
            </Button>
          </form>
        </CardContent>
        <ChangePassModal open={open} onClose={handleCloseModal} />
        <ChangePinModal open={open2} onClose={handleCloseModal2} />
      </Box>
    </>
  );
}
